export default __webpack_public_path__ + "static/media/okletsplay_logo-text.ddea8bab.png";